import stylesGlobal from '../../style';

const styles = {
  dataContainer: {
    height: 519,
    backgroundColor: stylesGlobal.neutral0,
    borderRadius: 8,
    padding: 16,
  },
  newsTitle: {
    color: stylesGlobal.neutral900,
    textDecoration: 'none',
  },
  buttonStockCode: {
    fontSize: 13,
  },
  buttonHoverStockCode: {
    background: 'none',
    fontSize: 13,
  },
  cardHeader: {
    border: 'none',
    background: 'none',
    boxSizing: 'unset',
    paddingLeft: 0,
    paddingRight: 0,
  },
};

export default styles;
